import React, { useEffect, useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./components/Navbar.css";
import { Link, NavLink, useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setActiveDropdown(null);
  }, [location.pathname]);

  const toggleMenu = () => {
    setMenuOpen((previousState) => !previousState);
    setActiveDropdown(null);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown((currentDropdown) =>
      currentDropdown === dropdownName ? null : dropdownName
    );
  };

  const closeNavigation = () => {
    setMenuOpen(false);
    setActiveDropdown(null);
  };

  const navLinkClass = ({ isActive }) =>
    isActive ? "mortbuzz-nav-link active" : "mortbuzz-nav-link";

  return (
    <nav
      className={`mortbuzz-navbar ${isScrolled ? "scrolled" : ""}`}
      aria-label="Main navigation"
    >
      <div className="mortbuzz-navbar-container">
        <div className="mortbuzz-brand">
          <Link
            to="/"
            onClick={closeNavigation}
            aria-label="Go to Monayra home page"
          >
            <img
              src="/images/Mortbuzz-logo.png"
              alt="Monayra Logo"
              className="mortbuzz-brand-logo"
            />
          </Link>
        </div>

        <button
          type="button"
          className={`mortbuzz-menu-toggle ${menuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
          aria-controls="mortbuzz-main-menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul
          id="mortbuzz-main-menu"
          className={`mortbuzz-menu ${menuOpen ? "show" : ""}`}
        >
          <li
            className={`mortbuzz-dropdown ${
              activeDropdown === "loans" ? "open" : ""
            }`}
          >
            <button
              type="button"
              className="mortbuzz-dropdown-trigger"
              onClick={() => toggleDropdown("loans")}
              aria-expanded={activeDropdown === "loans"}
            >
              <span>Apply Loan</span>
              <i className="bi bi-chevron-down"></i>
            </button>

            <ul className="mortbuzz-dropdown-menu">
              <li>
                <NavLink
                  to="/mortbuzz-home-loan"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-house-door"></i>
                  Home Loan
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/mortbuzz-loan-against-property"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-building"></i>
                  Loan Against Property
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/business-loan"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-briefcase"></i>
                  Business Loan
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/personal-loan"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-person-check"></i>
                  Personal Loan
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/car-loan"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-car-front"></i>
                  Car Loan
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/education-loan"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-mortarboard"></i>
                  Education Loan
                </NavLink>
              </li>

              <li className="mortbuzz-dropdown-divider"></li>

              <li>
                <NavLink
                  to="/apply-now"
                  className="mortbuzz-dropdown-apply"
                  onClick={closeNavigation}
                >
                  Apply Now
                  <i className="bi bi-arrow-right"></i>
                </NavLink>
              </li>
            </ul>
          </li>

          <li
            className={`mortbuzz-dropdown ${
              activeDropdown === "services" ? "open" : ""
            }`}
          >
            <button
              type="button"
              className="mortbuzz-dropdown-trigger"
              onClick={() => toggleDropdown("services")}
              aria-expanded={activeDropdown === "services"}
            >
              <span>Services</span>
              <i className="bi bi-chevron-down"></i>
            </button>

            <ul className="mortbuzz-dropdown-menu">
              <li>
                <NavLink
                  to="/bank-interest-rates"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-bank"></i>
                  Bank Interest Rates
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/interest-rates-banks"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-percent"></i>
                  Interest Rates
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/eligibility-criteria"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-person-vcard"></i>
                  Eligibility
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/emi-calculator"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-calculator"></i>
                  EMI Calculator
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/home-loan-tax-benefits"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-receipt"></i>
                  Home Loan Tax Benefits
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/how-to-apply"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-file-earmark-check"></i>
                  How to Apply
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/faq-section"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-question-circle"></i>
                  FAQs
                </NavLink>
              </li>
            </ul>
          </li>

          <li
            className={`mortbuzz-dropdown ${
              activeDropdown === "about" ? "open" : ""
            }`}
          >
            <button
              type="button"
              className="mortbuzz-dropdown-trigger"
              onClick={() => toggleDropdown("about")}
              aria-expanded={activeDropdown === "about"}
            >
              <span>About Us</span>
              <i className="bi bi-chevron-down"></i>
            </button>

            <ul className="mortbuzz-dropdown-menu">
              <li>
                <NavLink
                  to="/about-us"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-info-circle"></i>
                  About Monayra
                </NavLink>
              </li>

              {/*<li>
                <NavLink
                  to="/Career"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-people"></i>
                  Careers
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/society-activities"
                  className={navLinkClass}
                  onClick={closeNavigation}
                >
                  <i className="bi bi-buildings"></i>
                  Society Activities
                </NavLink>
              </li>
              */}
            </ul>
          </li>

          <li>
            <NavLink
              to="/contact"
              className={navLinkClass}
              onClick={closeNavigation}
            >
              Contact Us
            </NavLink>
          </li>

         {/* <li>
            <a
              href="https://blogs.mortbuzz.in/"
              className="mortbuzz-nav-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeNavigation}
            >
              Blogs
              <i className="bi bi-box-arrow-up-right mortbuzz-external-icon"></i>
            </a>
          </li>
          */}

          <li className="mortbuzz-mobile-apply">
            <Link
              to="/apply-now"
              className="mortbuzz-navbar-cta"
              onClick={closeNavigation}
            >
              Apply Now
              <i className="bi bi-arrow-right"></i>
            </Link>
          </li>
        </ul>

        <Link
          to="/apply-now"
          className="mortbuzz-navbar-cta mortbuzz-desktop-apply"
          onClick={closeNavigation}
        >
          Apply Now
          <i className="bi bi-arrow-right"></i>
        </Link>
      </div>

      {menuOpen && (
        <button
          type="button"
          className="mortbuzz-menu-backdrop"
          onClick={closeNavigation}
          aria-label="Close navigation menu"
        />
      )}
    </nav>
  );
};

export default Navbar;